import React from 'react';
import {TypicalMessage, TypicalMessageProps} from './TypicalMessage';
import {toDate} from './index';

export function OrderDeadlineChanged(props: TypicalMessageProps<'order.deadline-changed'>) {
    return <TypicalMessage
            model={props.model}
            options={props.options}
            replace={{
                was: toDate(props.model.message_details.was),
                became: toDate(props.model.message_details.became),
            }}
    />;
}
